<template>
  <v-btn :disabled="data_table_departamentos_carregando_dados" icon @click="excluirProdutoDoPedido">
    <v-icon>mdi-delete</v-icon>
  </v-btn>
</template>

<script>
import {excluirCategoriaDoPedido} from "../../../../../api/compraPorDepartamentos/ProdutosPedidoCompraTipo";
import {logout} from "../../../../../helpers";
import {data_table_departamentos_carregando_dados} from "../../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";

export default {
  name: "ExcluirProduto",
  mixins: [data_table_departamentos_carregando_dados],
  props: {
    linha: {
      type: Object,
      required: true
    }
  },
  methods: {
    excluirProdutoDoPedido() {
      const categoria = {
        idcategoria: this.linha.idcategoria,
        id_pedido: this.linha.id_pedido
      };

      this.$store.dispatch("loading/addRequisicao",
        excluirCategoriaDoPedido(categoria)
          .then(this.sucessoExclusao)
          .catch(logout)
      )
    },
    sucessoExclusao() {
      this.$emit('produto-excluido-carrinho', this.linha);
    }
  }
}
</script>

<style scoped>

</style>
